import PropTypes from 'prop-types';
import React from 'react';
import { InputDiv, InputLabelDiv, TimeInputField } from './InputStyles';
import moment from 'moment';

const TimeInput = ({
  input,
  meta,
  label,
  first,
  placeholder,
  disabled,
  hasDefaultValue
}) => {
  const { invalid, submitFailed } = meta;
  const showError = invalid && submitFailed ? 1 : 0;

  return (
    <InputDiv first={first}>
      <InputLabelDiv>{label}</InputLabelDiv>
      <TimeInputField
        disabled={disabled}
        error={showError}
        placeholder={placeholder}
        format='HH:mm'
        value={input.value ? moment.utc(input.value) : hasDefaultValue ? moment().utc(true) : null}
        onChange={(date) => { 
          let newDate = moment('2000-03-13')
          newDate.set({
            hour:   date.get('hour'),
            minute: date.get('minute'),
            second: date.get('second')
          });
          console.log('date', date, newDate);
          return newDate ? input.onChange(moment(newDate).utc(true)) : input.onChange('')
        }}
      />
    </InputDiv>
  );
};

TimeInput.propTypes = {
  label: PropTypes.string,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
};

export default TimeInput;